function readApiBaseUrlFromDom(): string | null {
    if (typeof document === 'undefined') return null;
    const meta = document.querySelector('meta[name="nibni-api-base-url"]') as HTMLMetaElement | null;
    const content = meta?.content?.trim() || '';
    return content ? content : null;
}

function isLocalDevHost(): boolean {
    if (typeof window === 'undefined') return false;
    return ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname);
}

function readApiBaseUrlFromWindow(): string | null {
    if (typeof window === 'undefined') return null;
    const anyWindow = window as any;
    const raw =
        anyWindow?.__nibni_CONFIG__?.API_BASE_URL ||
        anyWindow?.__nibni_CONFIG__?.apiBaseUrl ||
        anyWindow?.__APP_CONFIG__?.API_BASE_URL ||
        anyWindow?.__APP_CONFIG__?.apiBaseUrl ||
        null;
    return typeof raw === 'string' && raw.trim() ? raw.trim() : null;
}

function normalizeBaseUrl(raw: string): string {
    // Allow relative (e.g. "/server") or absolute bases.
    return raw.replace(/\/+$/, '');
}

function resolveApiBaseUrl(): string {
    const fromWindow = readApiBaseUrlFromWindow();
    if (fromWindow) return normalizeBaseUrl(fromWindow);

    const fromDom = readApiBaseUrlFromDom();
    if (fromDom) return normalizeBaseUrl(fromDom);

    // Local dev: point the frontend at the shared dev gateway by default.
    // Note: API calls in the app typically use paths like "/API2/..." so the base should be ".../server" (not ".../server/API2").
    if (isLocalDevHost()) return normalizeBaseUrl('https://dev.nibni.com/server');

    // Safe default for current hosting: same-origin Catalyst function gateway.
    if (typeof window !== 'undefined') return normalizeBaseUrl(`${window.location.origin}/server`);
    return '';
}

const API_BASE_URL = resolveApiBaseUrl();

export const IS_DEV_HOST =
    typeof window !== 'undefined' ? isLocalDevHost() : false;

export const API_CONFIG = {
    API_BASE_URL,

    // vNext services (preferred)
    AUTH_URL: `${API_BASE_URL}/Auth`,
    API2_URL: `${API_BASE_URL}/API2`,
    PUBLIC_URL: `${API_BASE_URL}/Public`,
    FILES_URL: `${API_BASE_URL}/Files`,

    // Legacy alias used by older code paths. Currency rates are now served by `/Public/currency/rates`.
    LEGACY_PUBLIC_API_URL: `${API_BASE_URL}/Public`,
};
